import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AccordionContent, Button } from 'alm-react-components';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { constants, Tag } from '../../../assets/constants/constants';
import { weekIn } from '../../../lib/utils';
import SvgIcon from '../../common/SvgIcon';
import { WatchRecording } from './WatchRecording';
import defaultImg from '/src/assets/images/default-image-library.png';
type ProgramWeekDetailProps = {
  course: any;
  index: number;
  timeZoneCode: any;
  pId: any;
  week: any;
  wIndex: number;
  programDetailObject:any
  currentQuarter:any,
  watchRecordingId:any
};

export const ProgramWeekDetail: React.FC<ProgramWeekDetailProps> = ({
  course,
  index,
  timeZoneCode,
  pId,
  week,
  wIndex,
  programDetailObject,
  currentQuarter,
  watchRecordingId
}) => {
  const navigate = useNavigate();

  const weekDetail = weekIn(index);
  const sequence = `${wIndex}${index}`;
  
  const gotToCourseDetailPage = (weekId: any, courseId: any, sequence: any) => {
    navigate(`/course-detail/${pId}/${weekId}/${courseId}?sequence=${sequence}`);
  };

  return (
    <AccordionContent className="text-base font-barlowLight pb-6">
      <div className="flex flex-col bg-fillMidGrayCard xl:space-x-2 lg:space-x-2 md:space-x-0 p-3 rounded-xl items-stretch grow-0 shrink-0 relative cursor-pointer">
        <div
          onClick={() => gotToCourseDetailPage(week.id, course.id, sequence)}
          className="flex flex-col md:flex-row grow-0 shrink-0"
        >
          <div className="flex-none relative md:ml-3 md:mt-3 ml-0 mt-0 rounded-lg border bg-fillLightGrayCard w-[333px] h-[198px] max-sm:w-[260px] max-sm:h-[160px] overflow-hidden">
            {course?.coverImage ? <img
              src={course?.coverImage ? course?.coverImage : weekDetail.image}
              alt="No Image"
              className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
              />: (
                <img
                  src={defaultImg}
                  alt={" "}
                  className="rounded-t-lg w-full h-full aspect-[3/2] object-cover"
                />
              )}
          </div>
          <div className="flex flex-col w-full lg:pr-20 md:pr-10 ml:0 md:ml-8 my-3 space-y-2">
            <p className="font-barlowLight text-xl">
              <span dangerouslySetInnerHTML={{ __html: t('Program.lesson') }} /> {index + 1}
            </p>
            <p className="font-opensansSemiBold lg:text-xl xl:text-2xl">{course?.name}</p>
            <p className="font-opensansMedium text-base text-formTextMute">{course.description}</p>

            <div className="mt-20 flex justify-end">
                <div>
                  {(course.state == constants.COMPLETED || course.state == constants.STARTED) && (
                    <div className="flex-shrink-0 inline-flex items-center  text-base font-opensansSemiBold text-gray-900 dark:text-white bg-grey mb-2 rounded-sm">
                      <Button
                        variant="outline"
                        className="font-normal bg-grey py-1 dark:border-grey"
                      >
                        <FontAwesomeIcon icon={faCheck} className="mr-2 text-sm" />
                        {course.state == constants.COMPLETED &&  <span dangerouslySetInnerHTML={{ __html: t('Common.completed') }} />}
                        {course.state == constants.STARTED && <span dangerouslySetInnerHTML={{ __html: t('Common.inProgress') }} />}
                      </Button>
                    </div>
                  )}
                </div>
            </div>
          </div>
          <div>
            <SvgIcon
              iconName="accordion-arrow-yellow"
              svgProp={{
                viewBox: '0 0 26 36',
                className: 'logo cursor-pointer absolute top-10 right-4',
                fill: '#61dafb',
              }}
            />
          </div>
        </div>
        {course.tags && course.tags.includes(Tag.liveclass)  && (
          <div className="md:flex lg:items-center lg:justify-between border-t-[1px] border-gray-600 pt-4 mt-6 space-y-5 lg:space-y-0">
            <WatchRecording
              liveClassdateStart={course?.liveClassdateStart}
              completionDeadline={course?.completionDeadline}
              timeZoneCode={timeZoneCode}
              isRecordingAvail={course.isRecordingAvail}
              gotToCourseDetailPage={gotToCourseDetailPage}
              courseId={course.id}
              weekId={week.id}
              course={course.name}
              pId={pId}
              program={programDetailObject.name}
              currentQuarter={currentQuarter}
              recordingId={watchRecordingId}

            />
          </div>
        )}
      </div>
    </AccordionContent>
  );
};
